export default __webpack_public_path__ + "82e91c069dad20a39997a56fe0915cae.csv";